import { buildPaginationContext } from "src/components/paginationContext.ts";
import { ContainerFilterProps, ContainerPagination } from "src/model/container.ts";

export const { Provider, usePaginationContext } = buildPaginationContext<ContainerPagination, ContainerFilterProps>();
